const CardSquare = (data) => {
  return data.map((item) => {
    const { title, href, image, paragraph } = item

    return {
      title,
      href,
      // featuredImage
      image: {
        src: image?.url,
        alt: image?.alt,
      },
      paragraph
    }
  })
}

export default CardSquare